import { FunctionComponent } from "react";
import { SHORTCUTS_ENUM } from "@utils/enums/shortcuts.enum";
import CrossIcon from "@static/core/icons/icon-cross.svg?react";

interface ShortcutProps {
  active: string;
  shortcut: string;
  count: number;
  onClick: () => void;
  className?: string;
}

const Shortcut: FunctionComponent<ShortcutProps> = ({
  active,
  shortcut,
  count,
  onClick,
  className = "",
}) => {
  return (
    <div className={`app-shortcut ${className}`}>
      <div className={`shortcut-container ${active}`} onClick={onClick}>
        <div className="shortcut-header">
          {SHORTCUTS_ENUM[shortcut].icon}
          {count !== null && shortcut !== "myDashboard" && (
            <div
              className={`shortcut-count text-${
                count === 0 ? "success" : count < 5 ? "tertiary" : "danger"
              }`}
            >
              <span>{count}</span>
            </div>
          )}
          <div className={`shortcut-close ${active}`}>
            <CrossIcon />
          </div>
        </div>
        <div className="shortcut-body">
          <span>{SHORTCUTS_ENUM[shortcut].label}</span>
        </div>
      </div>
    </div>
  );
};

export default Shortcut;
